import React from 'react';
import { Palette } from '@material-ui/icons';

const PaletteIcn = (props) => {
    return (
        <div>
            <Palette />
        </div>
    );
};

export default PaletteIcn;
